/** 5-minute TTL for historical report aggregations */
export const REPORT_API_CACHE_TTL_SECONDS = 300;

/** Coalesce report version bumps during concurrent order writes */
export const REPORT_CACHE_VERSION_THROTTLE_SECONDS = 30;

